import apiBase from "../../api/axios";

export const getPlantelsService = async (page = 1, search = "") => {
  let url = `v1/plantel/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const createPlantelService = async (payload) => {
  const response = await apiBase.post("v1/plantel/", payload);
  return response.data;
};

export const getPlantelByIdService = async (id) => {
  const response = await apiBase.get(`v1/plantel/${id}/`);
  return response.data;
};

export const updatePlantelService = async (id, payload) => {
  const response = await apiBase.put(`v1/plantel/${id}/`, payload);
  return response.data;
};

export const togglePlantelActiveService = async (id) => {
  const response = await apiBase.post(`v1/plantel/${id}/toggle_active/`);
  return response.data;
};

// Servicio para obtener lista de escuelas (para el selector)
export const getSchoolsOptionsService = async (search = "") => {
  let url = `v1/escuela/selectores/`;
  if (search) {
    url += `?search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getTalentsByPlantelService = async (plantelId, page) => {
  let url = `v1/talentos-plantel/talentos/?plantel=${plantelId}`;

  if (page) {
    url += `&page=${page}`;
  }

  const response = await apiBase.get(url);
  return response.data;
};

export const createTalentByPlantelService = async (payload) => {
  const response = await apiBase.post("v1/talentos-plantel/talentos/", payload);
  return response.data;
};

export const getTalentByPlantelById = async (id) => {
  const response = await apiBase.get(`v1/talentos-plantel/talentos/${id}/`);
  return response.data;
};

export const updateTalentByPlantelById = async (id, payload) => {
  const response = await apiBase.patch(
    `v1/talentos-plantel/talentos/${id}/`,
    payload,
  );
  return response.data;
};

export const toggleTalentActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/talentos/${id}/toggle_active/`,
  );
  return response.data.data;
};

export const getPhrasesByPlantelService = async ({
  talentoPlantelId,
  plantelId,
  isRandom,
  page = 1,
}) => {
  const params = new URLSearchParams();

  if (talentoPlantelId) params.append("talento_plantel", talentoPlantelId);
  if (plantelId) params.append("plantel", plantelId);
  if (isRandom !== undefined) params.append("is_random", isRandom);
  if (page) params.append("page", page);

  const response = await apiBase.get(
    `v1/talentos-plantel/frases/?${params.toString()}`,
  );

  return response.data;
};

export const getTalentsSelectorByPlantelService = async (plantelId) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/selectores/talentos/?plantel=${plantelId}`,
  );
  return response.data;
};

export const createPhraseByPlantelService = async (payload) => {
  const response = await apiBase.post("v1/talentos-plantel/frases/", payload);
  return response.data;
};

export const getPhraseByPlantelById = async (id) => {
  const response = await apiBase.get(`v1/talentos-plantel/frases/${id}/`);
  return response.data;
};

export const togglePhraseActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/frases/${id}/toggle_active/`,
  );
  return response.data;
};

export const getResponsePhrasesByPlantelService = async (plantelId) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/frases-respuesta/?plantel=${plantelId}`,
  );

  return response.data;
};

export const getResponsePhraseByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/frases-respuesta/${id}/`,
  );
  return response.data;
};

export const updateResponsePhraseService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/frases-respuesta/${id}/`,
    payload,
  );
  return response.data;
};
